/* eslint-disable react-hooks/exhaustive-deps */
import React, { ChangeEvent, useEffect, useMemo, useState } from "react";
import {
    CustomPlusCircled,
    MDPButtons,
    SettingsBlockHeader,
    SettingsBlockTitle,
} from "pages/settings/settingsPageStyles";
import {
    addMDPRow,
    ConfigFileDetails,
    getMDPOpenState,
    getMDPSources,
    getScheduleParams,
    resetMDPOpenStates,
    setSelectedSTSId,
    TickerConfig,
    updateMDPRow,
    getMDPPrefill,
    setMDPOpenState,
} from "store/reducers/SettingsSlice";
import { useDispatch } from "react-redux";
import MDPList from "./MDPList";
import {
    CustomTopCheckbox,
    MDPParamsBlockWrapper,
    MDPSettingsBlockWrapper,
    ShowAllDiv,
    TickersTitle,
} from "./mDPSettingsBlockStyles";
import { SearchInput } from "components/Inputs/inputsStyles";
import { useAppSelector } from "hooks/redux";
import MDPParamsBlock from "./MDPParamsBlock";
import BasedModal from "components/BaseModalComponents/BasedModal";
import ModalFooter from "components/BaseModalComponents/Footer/ModalFooter";
import {
    Button,
    ButtonsBlock,
    Container,
    Content,
    ModalBody,
    ParamName,
    Row,
    TypeSelect,
} from "../../FilterModal/filterModalStyles";
import { GreenArrow, TrashIcon } from "assets/images";
import { RedButton } from "components/Buttons/buttonsStyles";
import ModalHeader from "components/BaseModalComponents/Header/ModalHeader";
import Scrollbars from "react-custom-scrollbars";

const MDPSettingsBlock = ({
    config,
    isSavingError,
    groupName,
    handleDeleteConfig,
    configMetadata,
}: {
    config: TickerConfig;
    isSavingError: boolean;
    groupName: string;
    configMetadata?: ConfigFileDetails;
    handleDeleteConfig: (configId: number) => void;
}) => {
    const [isAllShown, setIsAllShown] = useState(false);
    const [showTrash, setShowTrash] = useState(false);
    const editMode = useAppSelector((state) => state.settings.editMode);
    const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(
        null,
    );
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { id, all_values } = config;

    const {
        MDPParamTypes,
        activeTicker,

        activeGroup,
        activeTabId,
        mdpOpenStates,
    } = useAppSelector((s) => s.settings);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(resetMDPOpenStates());
        setSelectedRowIndex(null);
    }, [activeTabId]);
    const selectedSTSId = useAppSelector((store) =>
        store.settings.selectedSTSId.find((sts) => sts.id === config.id),
    );

    const [searchMDPString, setSearchMDPString] = useState("");
    const [selectedScheduleId, setSelectedScheduleId] = useState(null);
    const [initSelectedScheduleId, setInitSelectedScheduleId] = useState(null);

    const params = all_values[0] || [];

    // открытые строки мдп
    useEffect(() => {
        if (!groupName || !activeTicker.name || !config.id) return;
        dispatch(
            getMDPOpenState({
                group_name: activeGroup.name.toString(),
                ticker_name: activeTicker.name,
                config_id: config.id,
                schedule_id: activeTicker.schedule_id || undefined,
            }),
        );
    }, [groupName, activeTicker.name, activeTabId]);
    useEffect(() => {
        if (!mdpOpenStates) return;

        const currentConfigOpenState = mdpOpenStates.find(
            (state) => state.config_id === config.id,
        );

        if (currentConfigOpenState?.open_rows?.length) {
            const firstOpen = Number(currentConfigOpenState.open_rows[0]) - 1;
            setSelectedRowIndex(firstOpen);
            const rowData = all_values[firstOpen + 1];
            if (rowData) {
                setSelectedRowIndex(firstOpen);
            }
        } else {
            setSelectedRowIndex(null);
        }
    }, [mdpOpenStates, config.id]);

    const isUseIdx = params.indexOf("isUse");

    const rowsWithRealIndex = useMemo(() => {
        return all_values.slice(1).map((row, realIndex) => ({
            row,
            originalIndex: realIndex,
        }));
    }, [all_values]);
    const currentTickerScheduleId = activeTicker.schedule_id;

    const filteredRowsWithIndex = useMemo(() => {
        return rowsWithRealIndex.filter(({ row, originalIndex }) => {
            if (
                selectedRowIndex !== null &&
                originalIndex === selectedRowIndex
            ) {
                return true;
            }
            const matchesSearch =
                !searchMDPString ||
                row[1].toLowerCase().includes(searchMDPString.toLowerCase());

            if (isAllShown) {
                return matchesSearch;
            }

            const matchesUse = isUseIdx !== -1 && row[isUseIdx] === "1";

            const matchesSchedule =
                currentTickerScheduleId === null ||
                row[0] === currentTickerScheduleId;

            return matchesSearch && matchesUse && matchesSchedule;
        });
    }, [
        rowsWithRealIndex,
        searchMDPString,
        isAllShown,
        isUseIdx,
        currentTickerScheduleId,
        selectedRowIndex,
    ]);

    useEffect(() => {
        if (selectedSTSId === undefined)
            dispatch(setSelectedSTSId({ id: config.id, value: null }));
        else {
            setSelectedScheduleId(selectedSTSId.value);
            setInitSelectedScheduleId(selectedSTSId.value);
        }
    }, [selectedSTSId]);

    useEffect(() => {
        setSelectedRowIndex(null);
    }, [activeTicker.name]);
    useEffect(() => {
        if (activeGroup?.name && activeGroup.name !== "Группа") {
            dispatch(getMDPSources(activeGroup.name));
        }
    }, [activeGroup?.name]);
    const handleAllShownCheckboxClick = (e: any) => {
        setIsAllShown(e.target.checked);
    };

    const availableSTSIds = useAppSelector(
        (store) => store.settings.availableSTSIds,
    );

    const handleSearchMDPChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchMDPString(e.target.value);
    };

    const updateField = (
        originalRowIndex: number,
        paramIdx: number,
        value: string,
    ) => {
        const row = all_values[originalRowIndex + 1];

        if (!row) return;
        const newRow = row.map((cell, j) => (j === paramIdx ? value : cell));

        dispatch(
            updateMDPRow({ configId: id, rowIndex: originalRowIndex, newRow }),
        );
    };

    const _onRestoreHandler = () => {
        setSelectedScheduleId(null);
    };

    const hasUnsavedNewRow = all_values
        .slice(1)
        .some((row) => row[row.length - 1] === "new_temp_flag");
    const canAddNewRow = !hasUnsavedNewRow;

    const createNewRow = () => {
        if (!canAddNewRow) return;

        (
            dispatch(
                getMDPPrefill({
                    ticker_name: activeTicker.name,
                    group_name: activeGroup.name,
                    workspace_id: activeTabId ?? undefined,
                    schedule_id: activeTicker.schedule_id || undefined,
                    index:
                        activeTicker.index !== -1
                            ? activeTicker.index
                            : undefined,
                }),
            ) as any
        )
            .then((result: any) => {
                if (result?.meta?.requestStatus === "fulfilled") {
                    const response = result.payload;

                    let newRowData: string[] = [];
                    if (response?.values?.[1]) {
                        newRowData = [...response.values[1]];
                    } else {
                        console.warn("Неожиданный формат префилла", response);
                        return;
                    }

                    const finalNewRow = [...newRowData, "new_temp_flag"];

                    dispatch(
                        addMDPRow({ configId: config.id, newRow: finalNewRow }),
                    );

                    setTimeout(() => {
                        const newOriginalIndex = config.all_values.length;

                        dispatch(
                            setMDPOpenState({
                                group_name: activeGroup.name,
                                ticker_name: activeTicker.name,
                                config_id: config.id,
                                open_row: String(newOriginalIndex),
                                schedule_id:
                                    activeTicker.schedule_id || undefined,
                            }),
                        );

                        setSelectedRowIndex(newOriginalIndex - 1);
                    }, 100);
                } else {
                    console.error("Префилл не удался:", result);
                }
            })
            .catch((err) => {
                console.error("Ошибка префилла MDP:", err);
            });
    };

    return (
        <MDPSettingsBlockWrapper
            isHorizontal={config.is_horizontal}
            isOpen={selectedRowIndex !== null}
        >
            <SettingsBlockHeader
                onMouseEnter={() => setShowTrash(true)}
                onMouseLeave={() => setShowTrash(false)}
                style={{ position: "relative" }}
            >
                <SettingsBlockTitle
                    style={{
                        width: "fit-content",
                    }}
                >
                    MDP
                </SettingsBlockTitle>
                <MDPButtons>
                    {showTrash && editMode && (
                        <TrashIcon
                            onClick={() => handleDeleteConfig(config.id)}
                            style={{
                                width: 20,
                                height: 20,
                                cursor: "pointer",
                                stroke: "#ff4d4f",
                                opacity: 0.85,
                            }}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.opacity = "1")
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.opacity = "0.85")
                            }
                        />
                    )}
                    <CustomPlusCircled
                        style={{
                            cursor: canAddNewRow ? "pointer" : "not-allowed",
                            width: "24px",
                            height: "24px",
                            opacity: canAddNewRow ? 1 : 0.5,
                        }}
                        onClick={canAddNewRow ? createNewRow : undefined}
                    />
                    <RedButton
                        green
                        onClick={() => {
                            setIsModalOpen(true);
                            dispatch(getScheduleParams({ group: activeGroup.name,ticker: activeTicker.name}));
                        }}
                        small
                    >
                        Время MDP
                    </RedButton>
                </MDPButtons>
            </SettingsBlockHeader>
            <TickersTitle isHorizontal={config.is_horizontal}>
                <ShowAllDiv>
                    <CustomTopCheckbox onChange={handleAllShownCheckboxClick} />
                    Показать все
                </ShowAllDiv>
                {isAllShown && (
                    <SearchInput
                        onChange={handleSearchMDPChange}
                        onKeyDown={(e) => e}
                        type="text"
                        placeholder={"Поиск"}
                        className="mdpSearch"
                    />
                )}
            </TickersTitle>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    flex: 1,
                    minHeight: "500px",
                    gap: "16px",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        flex: 1,
                        minHeight: 0,
                        maxWidth: config.is_horizontal ? "330px" : "100%",
                        gap: "16px",
                    }}
                >
                    {searchMDPString ? (
                        <MDPList
                            isSavingError={isSavingError}
                            updateField={updateField}
                            config={config}
                            setSelectedRowIndex={setSelectedRowIndex}
                            params={params}
                            rows={filteredRowsWithIndex}
                            selectedRowIndex={selectedRowIndex}
                            configMetadata={configMetadata}
                        />
                    ) : (
                        <MDPList
                            isSavingError={isSavingError}
                            updateField={updateField}
                            config={config}
                            setSelectedRowIndex={setSelectedRowIndex}
                            params={params}
                            rows={filteredRowsWithIndex}
                            selectedRowIndex={selectedRowIndex}
                            configMetadata={configMetadata}
                        />
                    )}
                </div>

                {config.is_horizontal && (
                    <MDPParamsBlockWrapper isOpen={selectedRowIndex !== null}>
                        <Scrollbars
                            autoHide={false}
                            autoHideTimeout={1000}
                            autoHideDuration={200}
                            renderThumbVertical={(props) => (
                                <div
                                    {...props}
                                    style={{
                                        ...props.style,
                                        backgroundColor: "rgba(0,0,0,0.2)",
                                        width: "6px",
                                        borderRadius: "10px",
                                    }}
                                />
                            )}
                            style={{ width: "100%", height: "100%" }}
                        >
                            <MDPParamsBlock
                                rows={filteredRowsWithIndex}
                                selectedRowIndex={selectedRowIndex}
                                configMetadata={configMetadata}
                                params={params}
                                onFieldChange={(idx, value) => {
                                    if (selectedRowIndex !== null) {
                                        updateField(
                                            selectedRowIndex,
                                            idx,
                                            value,
                                        );
                                    }
                                }}
                                MDPParamTypes={MDPParamTypes}
                            />
                        </Scrollbars>
                    </MDPParamsBlockWrapper>
                )}
            </div>
            <BasedModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                style={{
                    overlay: {
                        position: "fixed",
                        zIndex: 100,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                    },
                    content: {
                        position: "static",
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        width: "360px",
                        padding: 0,
                        boxShadow: "0px 0px 5px rgba(49, 69, 49, 0.14)",
                        borderRadius: "10px",
                    },
                }}
            >
                <Container>
                    <ModalHeader>
                        <div>Фильтры MDP</div>
                        <ButtonsBlock>
                            <Button onClick={_onRestoreHandler}>
                                <TrashIcon />
                            </Button>
                        </ButtonsBlock>
                    </ModalHeader>
                    <ModalBody
                        thumbSize={60}
                        renderThumbVertical={(props: any) => (
                            <div
                                {...props}
                                style={{
                                    ...props.style,
                                    backgroundColor: "#7CBE7B",
                                    width: "6px",
                                    borderRadius: "10px",
                                }}
                            />
                        )}
                    >
                        <Row>
                            <Content
                                style={{ justifyContent: "space-between" }}
                            >
                                <ParamName>Source.type.shedule.ID</ParamName>
                                <TypeSelect
                                    value={{
                                        label:
                                            selectedScheduleId !== null
                                                ? selectedScheduleId
                                                : "Все",
                                        value: selectedScheduleId,
                                    }}
                                    onChange={(value: any) =>
                                        setSelectedScheduleId(value)
                                    }
                                    suffixIcon={
                                        <GreenArrow className="ant-select-suffix" />
                                    }
                                    placeholder="Тип фильтрации"
                                    options={[
                                        { label: "Все", value: null },
                                        ...availableSTSIds.map((id) => {
                                            return { label: id, value: id };
                                        }),
                                    ]}
                                />
                            </Content>
                        </Row>
                    </ModalBody>
                    <ModalFooter
                        //disabled_apply_button={false}
                        onApplyClick={() => {
                            dispatch(
                                setSelectedSTSId({
                                    id: config.id,
                                    value: selectedScheduleId,
                                }),
                            );
                            setIsModalOpen(false);
                        }}
                        applyText="Применить"
                        onCancelClick={() => {
                            setSelectedScheduleId(initSelectedScheduleId);
                            setIsModalOpen(false);
                        }}
                        cancelText="Отменить"
                        buttonBoxStyle={{
                            justifyContent: "space-between",
                            gap: 0,
                        }}
                    ></ModalFooter>
                </Container>
            </BasedModal>
        </MDPSettingsBlockWrapper>
    );
};

export default MDPSettingsBlock;
